import { defineRecipe, defineSlotRecipe } from '@chakra-ui/react'

export const buttonRadiusRecipe = defineRecipe({
  base: {
    borderRadius: 'l1',
  },
})

export const badgeRadiusRecipe = defineRecipe({
  base: {
    borderRadius: 'l1',
  },
})

export const inputRadiusRecipe = defineRecipe({
  base: {
    borderRadius: 'l2',
  },
})

export const inputAddonRadiusRecipe = defineRecipe({
  base: {
    borderRadius: 'l2',
  },
})

export const textareaRadiusRecipe = defineRecipe({
  base: {
    borderRadius: 'l2',
  },
})

export const cardRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'header', 'body', 'footer', 'title', 'description'],
  base: {
    root: {
      borderRadius: 'l3',
    },
    title: {
      textStyle: 'cardTitle',
    },
  },
})

export const tagRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'closeTrigger', 'startElement', 'endElement'],
  base: {
    root: {
      borderRadius: 'l1',
    },
  },
})

export const tabsRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'trigger', 'list', 'content', 'contentGroup', 'indicator'],
  base: {
    root: {
      '--tabs-trigger-radius': 'radii.l1',
    },
    list: {
      borderRadius: 'l1',
    },
    trigger: {
      borderRadius: 'l1',
    },
    indicator: {
      borderRadius: 'l1',
    },
  },
  variants: {
    variant: {
      enclosed: {
        list: {
          borderRadius: 'l1',
        },
      },
    },
  },
})

export const segmentGroupRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'item', 'indicator', 'label', 'itemText', 'itemControl'],
  base: {
    root: {
      '--segment-radius': 'radii.l1',
    },
  },
})

export const statRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'helpText', 'valueText', 'valueUnit', 'indicator'],
  base: {
    root: {
      borderRadius: 'l2',
    },
  },
})

export const alertRadiusRecipe = defineSlotRecipe({
  slots: ['title', 'description', 'root', 'indicator', 'content'],
  base: {
    root: {
      borderRadius: 'l2',
    },
  },
})

export const toastRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'title', 'description', 'indicator', 'closeTrigger', 'actionTrigger'],
  base: {
    root: {
      borderRadius: 'l1',
    },
    actionTrigger: {
      borderRadius: 'l1',
    },
    closeTrigger: {
      borderRadius: 'l1',
    },
  },
})

export const actionBarRadiusRecipe = defineSlotRecipe({
  slots: ['positioner', 'content', 'separator', 'selectionTrigger', 'closeTrigger'],
  base: {
    content: {
      borderRadius: 'l3',
    },
    selectionTrigger: {
      borderRadius: 'l1',
    },
  },
})

export const nativeSelectRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'field', 'indicator'],
  base: {
    field: {
      borderRadius: 'l2',
    },
  },
})

export const numberInputRadiusRecipe = defineSlotRecipe({
  slots: [
    'root',
    'control',
    'label',
    'input',
    'valueText',
    'incrementTrigger',
    'decrementTrigger',
    'scrubber',
  ],
  base: {
    input: {
      borderRadius: 'l2',
    },
  },
})

export const pinInputRadiusRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label', 'input'],
  base: {
    input: {
      borderRadius: 'l2',
    },
  },
})

export const selectRadiusRecipe = defineSlotRecipe({
  slots: [
    'root',
    'label',
    'trigger',
    'indicator',
    'indicatorGroup',
    'content',
    'positioner',
    'item',
    'itemText',
    'itemIndicator',
    'itemGroup',
    'itemGroupLabel',
    'clearTrigger',
  ],
  base: {
    trigger: {
      borderRadius: 'l2',
    },
  },
})

export const comboboxRadiusRecipe = defineSlotRecipe({
  slots: [
    'root',
    'label',
    'control',
    'input',
    'trigger',
    'positioner',
    'content',
    'item',
    'itemText',
    'itemIndicator',
    'itemGroup',
    'itemGroupLabel',
    'clearTrigger',
    'indicatorGroup',
    'empty',
  ],
  base: {
    input: {
      borderRadius: 'l2',
    },
  },
})

export const tagsInputRadiusRecipe = defineSlotRecipe({
  slots: [
    'root',
    'label',
    'control',
    'input',
    'clearTrigger',
    'item',
    'itemPreview',
    'itemText',
    'itemDeleteTrigger',
  ],
  base: {
    root: {
      borderRadius: 'l2',
    },
  },
})
